module.exports = __webpack_public_path__ + "img/edge_hebergements_chambre_hote.97d6e4ff.svg";